/* eslint-disable react/require-default-props */
import React, { useEffect, useRef } from 'react';
/**
 * PopupSearchInput
 * Optional pinned search bar for filtering popup content in real time.
 * Always rendered at the top of the popup container; does not scroll.
 * Placeholder defaults to "Search" per Quimby content guidelines.
 * @version 1.0.0
 * @since 2026-03-27
 */
export function PopupSearchInput({ value, onChange, placeholder = 'Search', variant = 'default' }) {
    const inputRef = useRef(null);
    // Imperatively focus on mount so focus works reliably inside Kendo portals.
    // autoFocus is unreliable for elements rendered into portals across browsers.
    useEffect(() => {
        var _a;
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, []);
    return (React.createElement("div", { className: `popup__section qmb-ui-popup__search qmb-ui-popup__search--${variant}` },
        React.createElement("input", { ref: inputRef, type: "text", className: "qmb-ui-popup__search-input", value: value, onChange: (e) => onChange(e.target.value), placeholder: placeholder, "aria-label": placeholder, autoComplete: "off" }),
        React.createElement("i", { className: "fa-light fa-magnifying-glass qmb-ui-popup__search-icon", "aria-hidden": "true" })));
}
PopupSearchInput.displayName = 'PopupSearchInput';
